import Cookies from 'js-cookie'

const TokenKey = 'User-Flow-Token'

export function getToken () {
  if (window.isAdmin === true) return window.rootToken
  return window.rootToken || Cookies.get(TokenKey)
}

// Admin tokens are intentionally kept in memory so opening an admin URL does
// not overwrite the currently logged-in user's cookie.
export function isAdminMode () {
  return window.isAdmin === true
}

export function setAdminToken (token) {
  window.rootToken = token
  window.isAdmin = true
  return token
}

export function setToken (token, exp = false) {
  return Cookies.set(TokenKey, token, { expires: exp ? 30 : undefined })
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
